import { Component, inject, input, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-klaviyo-forms',
  imports: [],
  templateUrl: './klaviyo-forms.component.html'
})
export class KlaviyoFormsComponent implements OnInit {

  #sanitizer = inject(DomSanitizer);

  formId = input.required<string>();
  publicApiKey = environment.apis.klaviyo.publicApiKey;

  iframeSrc!: SafeResourceUrl;

  ngOnInit() {
    const rawUrl = `/assets/klaviyo/klaviyo-form.html?form=${this.formId()}&api=${this.publicApiKey}`;
    this.iframeSrc = this.#sanitizer.bypassSecurityTrustResourceUrl(rawUrl);
  }

}
